import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {

  notifications: null,
  notificationsError: false,
  notificationsLoading: false,
  refreshNotifications: true,
  noMoreNotifications: false,

  // success rates list
  totalNotifications: null,
  totalUnread: null,
  notificationsPage: 0,
  notificationsPerPage: 10

}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
